import { RegisterHttpService } from './register.service';

export function createRegisterHttpService(baseURL: string) {
    return new RegisterHttpService({ baseURL });
}

export const ServiceRegister = createRegisterHttpService(import.meta.env.VITE_API_URL);
